<template>
  <div class="container">
    <div class="row justify-content-md-center align-items-center">
      <div class="col-lg-4">
        <form class="login">
          <div class="form-group">
            <h3>New Account</h3>
            <input class="form-control" type="text" v-model="email" placeholder="Email" />
            <input class="form-control" type="password" v-model="password" placeholder="Choose a password" />
            <button v-on:click.prevent="signUp" class="btn btn-primary">Sign up</button>
            <router-link to="/login">Back to login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'signUp',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    // comparePasswords () {
    //   return this.password !== this.confirmPassword ? 'Passwords do not match' : ''
    // },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    signUp (state, user) {
      this.$store.dispatch('signUserUp', {email: this.email, password: this.password})
     // this.$router.push('/customize')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue